/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spinner-wrapper{display:block;position:-webkit-sticky;position:sticky;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,.9);z-index:100000}.spinner-wrapper mat-spinner{position:absolute;left:50%;margin-left:-30px;top:50%;margin-top:-30px}.mat-slide-toggle-content{white-space:initial!important}"];
export { styles as styles };
